<template>
  <div class="card shadow h-100">
    <div class="card-header bg-transparent border-0">
      <h6>Lista</h6>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" :class="tabSelecionado == 'inserido' ? 'active' : '' " href="#" @click="tab('inserido')">Aceitos</a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="alert alert-success fade show" role="alert" v-show="msgSuccess.length > 0">
        <div v-for="(msg, i) in msgSuccess" v-bind:key="i">{{msg}}
        </div>
      </div>
      <div v-if="lista.length  == 0">Nenhum item encontrado</div>
      <div
        class="table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl"
        style="max-height:500px; overflow-y: auto"
        v-else
      >
        <table
          class="table table-borderless table-hover table-sm table-md table-lg table-xl table-condensed"
        >
          <thead>
            <tr class="d-flex">
              <th class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1" v-show="tabSelecionado == 'inserido'">Ação</th>
              <th class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2">Data Aceitação</th>
            </tr>
          </thead>
          <tbody>
            <tr class="d-flex" v-for="(objeto) of lista" v-bind:key="objeto.data">
              <td class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1" v-show="tabSelecionado == 'inserido'">
                <button
                  type="button"
                  class="btn btn-xl btn-lg btn-md btn-sm btn-outline-info"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Visualizar"
                  @click="showModal(objeto)"
                >
                  <li class="oi oi-eye"></li>
                </button>
              </td>
              <td
                class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2"
              >{{objeto.data | formatDatetime}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <modal v-show="isModalVisible" @close="closeModal">
      <span slot="header">Termo de Responsabilidade</span>
      <div slot="body" >
        
          <div class="col-12">
            <label class="label-black">Data Aceitação:</label>
            <span>{{objeto.data | formatDatetime}}</span>
          </div>
          <br/>
          
          <div v-html="objeto.texto" class="col-12"></div>
      </div>
    </modal>
  </div>
</template>

<script>
import http from "./../../../axios";
import modal from "../../utils/Modal";

export default {
  name: "TermoResponsabilidadeListaDetalhada",
  components: {
    modal: modal
  },
  data() {
    return {
      lista: [],
      isModalVisible: false,
      carregando: false,
      showErrors: false,
      msgSuccess: [],
      objeto: {},
      tokens: {},
      tabSelecionado: "inserido"
    };
  },
  created: function() {
    this.getTokens();
    this.getlista();
  },
  methods: {
    tab: function(selecionado){
      this.tabSelecionado = selecionado;
    },
    showModal(objetoTemp) {
      this.objeto = { };
      this.objeto = objetoTemp;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getlista: function() {
      this.$Progress.start();
      this.lista = [];
      http
        .get(`/api/cooperado/termoresponsabilidade/aceito/${this.tokens.id}/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            for(var i = 0; i < r.data.result.length; i++){
                this.lista.push(r.data.result[i]);
            }
          } else {
            this.lista = [];
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
    deletarobjeto: function() {
      this.msgSuccess = [];
      this.closeModal()
      this.$Progress.start();
        http
          .delete(`api/cooperado/${this.tokens.id}/objeto/${this.objeto.id}`, {
            headers: { "token-cooperado-api": this.tokens.token }
          })
          .then(r => {
            if (r.data.statusCode == 200) {
              this.msgSuccess.push("Declaração deletada com sucesso!");
              this.$Progress.finish()
              this.getlista();
            }
          })
          .catch(error => {
            this.$Progress.fail()
            if (error.response) {
              if (error.response.status >= 500) {
                this.$router.push("/");
              }else{
                this.$router.push("/TermoResponsabilidadeLista");
              }
            } else if (error.request) {
                this.$router.push("/");
            } else {
              console.log("Error", error.message);
                this.$router.push("/");
            }
          });
    },
    getTokens: function() {
      this.tokens = this.$cooperadowebapi.tokens.get("usuario");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/termoResponsabilidade/TermoResponsabilidadeListaDetalhada.vue